import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import TextField from '@material-ui/core/TextField';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import FooterActions from '../FooterActions/FooterActions';
import authSchema from '../../schemas/authSchema';
import styles from './loginForm.module.scss';

export default memo(function LoginForm(props) {
    const { t } = useTranslation(['common', 'validations', 'auth']);

    const handleSubmit = values => props.login(values.username, values.password, props.history, props.location);

    return (
        <div className={styles.formContainer}>
            <Formik
                initialValues={{
                    username: props.username,
                    password: ''
                }}
                validationSchema={authSchema}
                onSubmit={handleSubmit}
                render={formProps => (
                    <Form>
                        <div className={styles.fieldsContainer}>
                            <TextField
                                type="text"
                                label={t('common:USER')}
                                name="username"
                                value={formProps.values.username}
                                onChange={formProps.handleChange}
                                onBlur={formProps.handleBlur}
                                className={styles.field}
                                error={formProps.touched.username && !!formProps.errors.username}
                                helperText={
                                    formProps.touched.username && !!formProps.errors.username
                                        ? <span>{t(`validations:${formProps.errors.username}`)}</span>
                                        : ''
                                }
                            />
                            <TextField
                                type="password"
                                label={t('common:PASSWORD')}
                                name="password"
                                value={formProps.values.password}
                                onChange={formProps.handleChange}
                                onBlur={formProps.handleBlur}
                                className={styles.field}
                                error={formProps.touched.password && !!formProps.errors.password}
                                helperText={
                                    formProps.touched.password && !!formProps.errors.password
                                        ? <span>{t(`validations:${formProps.errors.password}`)}</span>
                                        : ''
                                }
                            />
                        </div>
                        <LoaderButton dictionary="auth" inProgress={props.isLogginIn} text="SIGN_IN" />
                    </Form>
                )}
            />
            <FooterActions />
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.username === nextProps.username &&
        prevProps.isLogginIn === nextProps.isLogginIn &&
        prevProps.login === nextProps.login
);
